




/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'
import StatusStore from '@finx/web-repository/src/stores/Status'
import { getModule } from 'vuex-module-decorators'
import LogoutConfigStore from '@/store/LogoutConfigStore'

@Component
export default class ViewLogout extends Vue {
  get logoutConfigStore() {
    return getModule(LogoutConfigStore, this.$store)
  }

  async mounted() {
    StatusStore.commit('ATIVO', false)
    StatusStore.commit('SHOW', false)
    await this.logoutConfigStore.authLogout(this.$user.profile.sub)
  }
}
